module.exports = __webpack_public_path__ + "img/appstoreImg.577d5c28.png";